import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmQueuesIssueRoute: InvariantJiraRoute = {
	name: 'csm-queues-issue',
	path: '/jira/customer-service-management/projects/:projectKey/queues/issue/:issueKey',
	exact: true,
};
